import { dataBooksBookmark } from 'dls-icons-data'
import { createIcon } from '../common'

const IconBooksBookmark = /*#__PURE__*/createIcon(dataBooksBookmark)
export default IconBooksBookmark
